import { useState } from 'react';
import { Container } from './styles';
import { useAuth } from "../../../contexts/UserContext";
import {
    IconPendency,
} from "../../icons";
import ModalPendenciaAdicionar from '../ModalPendencia/ModalPendenciaAdicionar';
import ModalResolverPendencia from '../ModalPendencia/ModalResolverPendencia';
import CardListaPendenciaPagamento from '../CardListaPendenciaPagamento';
import CardListaPendenciaComum from '../CardListaPendenciaComum';
import ContadorPendencias from '../ContadorPendencias';

interface IProposta {
    id_proposta: any,
    id_usuario: any,
    id_servico: any,
    id_comarca: any,
    tags: any,
    arquivos: any,
    numero_processo: string,
    nome_cliente: string,
    valor_cliente: string,
    codigo_cliente: string,
    prazo_aceite: string,
    prazo_para_conclusao: string,
    dias_uteis_para_conclusao: string,
    orientacoes: string,
    tipo_audiencia: string,
    data: any,
    profissional_necessario: string,
    modalidade: string,
    endereco_virtual: string,
    rua: string,
    bairro: string,
    cep: string,
    numero: string,
    complemento: string,
    valor_profissional?: any,
    pendencias?: any,
    pendente_de_orientacao?: any,
    tipo: string,
}

export default function BlocoPendencias({
    setUpdate,
    novaPendenciaPagamento,
    setNovaPendenciaPagamento,
    proposta,
    profissional,
    arquivos,
    enviarArquivos,
    solicitante=false
}: {
    setUpdate: (update: any) => void,
    novaPendenciaPagamento: boolean,
    setNovaPendenciaPagamento: (novaPendenciaPagamento: boolean) => void,
    proposta: IProposta|any;
    profissional: any;
    arquivos: any;
    enviarArquivos: (arquivos: any) => void;
    solicitante?: boolean;
}) {
    const [ pendenciaAberta, setPendenciaAberta ] = useState<any>();
    const [ modalPendencies, setModalPendencies ] = useState<any>();
    const [ pendencieType, setPendencieType ] = useState<any>('');

    const [ modalResolverPendencia, setModalResolverPendencia ] = useState<any>();
    const [ pendenciaResolver, setPendenciaResolver ] = useState<any>();

    const { user } = useAuth();


    function setModalNovo(modal: boolean) {

        setModalPendencies(modal);
        setNovaPendenciaPagamento(modal);
    }

    function resolvePendencia(pendencia: any) {
        setPendenciaResolver(pendencia);
        setModalResolverPendencia(true);
    }

    return (
        <Container>

            <ModalPendenciaAdicionar
                modalAtivo={modalPendencies || novaPendenciaPagamento}
                setModalAtivo={setModalNovo}
                tipoPendencia={pendencieType}
                setTipoPendencia={setPendencieType}
                id_proposta={proposta.id_proposta}
                setUpdate={setUpdate}
                pagamento={novaPendenciaPagamento}
            />

            {
                user.profile !== 'Solicitante' &&
            <ModalResolverPendencia
                modalAtivo={modalResolverPendencia}
                setModalAtivo={setModalResolverPendencia}
                pendencia={pendenciaResolver}
                profissional={profissional}
                arquivos={arquivos}
                enviarArquivos={enviarArquivos}
            />
            }

            <span>Pendências</span>
            <ContadorPendencias
                id_proposta={proposta.id_proposta}
                setPendenciaAberta={setPendenciaAberta}
                pendenciaAberta={pendenciaAberta}
                solicitante={user.profile === 'Solicitante'}
            />


            {   pendenciaAberta 
                ?
                    proposta.pendencias?.length > 0 
                    ?
                        proposta.pendencias.map((row: any) => (
                            ['documentacao', 'informacao', 'orientacao', 'correcao', 's_informacao'].includes(row.tipo)
                            ?   
                            <CardListaPendenciaComum 
                                pendencia={row} 
                                key={row.id_pendencia}
                                resolvePendencia={() => resolvePendencia(row)}
                            />
                            :   <CardListaPendenciaPagamento 
                                    pendencia={row} 
                                    key={row.id_pendencia}
                                    resolvePendencia={() => resolvePendencia(row)}
                                />
                        ))
                    :   <div className="empty">Sem pendências no momento</div> 
                :   ''
            }
            {
                (user.profile === 'comum' || user.profile === 'Solicitante') &&
                <div
                    className="add"
                    onClick={() => setModalPendencies(true)}
                >
                    <IconPendency />
                    Adicionar pendências
                </div>
            }

        </Container>

    );
}